export default __webpack_public_path__ + "static/media/phone.e16330c0.svg";